export const hexToRgba: (hex: string, alpha: number) => string = (hex: string, alpha: number = 1): string => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let c: any;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split('');
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (c.length === 3) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    // eslint-disable-next-line  max-len
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
    c = `0x${c.join('')}`;

    return `rgba(${[(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',')}, ${alpha})`;
  }
  throw new Error('Bad Hex');
};
